// src/components/VisitorContactWidget/components/ContactWidgetLauncher.jsx

import React from "react";

import {
  FiMessageCircle,
  FiX,
} from "react-icons/fi";

export default function ContactWidgetLauncher({
  isOpen,
  unreadCount = 0,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={
        isOpen
          ? "Fermer la messagerie"
          : "Ouvrir la messagerie"
      }
      className="group relative flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#123B57] to-[#2EA7E0] text-2xl text-white shadow-[0_18px_45px_rgba(18,59,87,0.35)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(18,59,87,0.45)]"
    >
      {isOpen ? <FiX /> : <FiMessageCircle />}

      {!isOpen && unreadCount > 0 && (
        <span className="absolute -right-1 -top-1 flex h-6 min-w-6 items-center justify-center rounded-full border-2 border-white bg-red-500 px-1 text-xs font-semibold text-white">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}

      {!isOpen && (
        <span className="pointer-events-none absolute right-[72px] hidden whitespace-nowrap rounded-xl bg-[#123B57] px-3 py-2 text-sm font-semibold text-white opacity-0 shadow-lg transition group-hover:opacity-100 sm:block">
          Besoin d’aide ?
        </span>
      )}
    </button>
  );
}